import { Suspense, lazy } from 'react';
import CommonSkeleton from 'components/common/skeleton/CommonSkeleton';

const WeblinkFlushIndex = lazy(() => import('components/weblinkFlush/WeblinkFlushIndex'));

const WeblinkFlushPage = () => {
	return (
		<div className='page-content user-module'>
			<Suspense fallback={<CommonSkeleton />}>
				<WeblinkFlushIndex />
			</Suspense>
		</div>
	);
};
export default WeblinkFlushPage;
